import React from 'react';
import { motion } from 'framer-motion';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  showWordmark?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', className = '', showWordmark = false }) => {
  // When showWordmark is true, show the full logo (emblem + text).
  // When false, show only the emblem portion cropped from the top of the image.
  const dimensions = {
    sm: showWordmark ? 'h-12' : 'h-8 w-8',
    md: showWordmark ? 'h-20' : 'h-10 w-10',
    lg: showWordmark ? 'h-24' : 'h-14 w-14',
    xl: showWordmark ? 'h-36' : 'h-24 w-24',
  };

  return (
    <motion.div
      className={`${className} flex items-center justify-center`}
      whileHover={{ scale: 1.03 }}
      transition={{ duration: 0.2 }}
    >
      <img
        src="/nestbloom-logo.png"
        alt="NestBloom"
        className={`${dimensions[size]} object-contain`}
      />
    </motion.div>
  );
};

export default Logo;
